import { createEvent } from 'effector'
import { IFilters, IPagination } from '../types'

export const applyFilters = createEvent()
export const initialize = createEvent()
export const reset = createEvent()
export const setFilters = createEvent<Partial<IFilters>>()
export const setPagination = createEvent<Partial<IPagination>>()
